<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaOrdemServico"
        sort-name="descricao"
        title-table="Ordem de Serviços"
        module="ordemServicoModule"
        @add="addNew"
        @edit="edit"
      />
      <FormOrdenServico v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormOrdenServico from './form/FormOrdemServico.vue'

export default {
  name: 'Convenio',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormOrdenServico
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('ordemServicoModule', {
      listaOrdemServico: (state) => state.listaOrdemServico
    })
  },
  data() {
    return {
      ehAssociado: false,
      showCpfAssociado: true,
      showForm: false,
      columns: [
        {
          label: 'Descrição',
          field: 'descricao'
        },
        {
          label: 'Data de Inicio',
          field: 'dataInicio',
          formatFn: this.formatarData
        },
        {
          label: 'Responsavel',
          field: 'responavelNome',
          sortable: true
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ]
    }
  },
  methods: {
    formatarData(val) {
      if (val) {
        return val.replaceAll('-', '/')
      }
      return val
    },
    async addNew() {
      this.showForm = true
    },
    async edit(data) {
      this.$store.dispatch('ordemServicoModule/prepareToEdit', data)
      this.showForm = true
    },
    async cancelar() {
      this.showForm = false
    }
  }
}
</script>
